/**
 * IronbodyMk2SkillEffect — Grit ironbody-path evolution, replaces Ironbody.
 *
 * Denser crystalline shell: 35% DR, only 20% movement penalty, 0.35s
 * stagger on hits. Inherits Hardening (damageReduction bonus) and
 * Grounded (knockbackRecoilDamage) via the ironbody upgrade chain.
 *
 * Implemented as a subclass of IronbodySkillEffect with evolved defaults.
 * Resolver queries use 'ironbody' scope so upgrades with
 * enhancesId: "ironbody" apply automatically.
 *
 * Pure logic — no Phaser dependencies.
 *
 * @see ADR-064 (attunement shared systems architecture)
 * @see grit-spec.md § Ironbody Mk.II
 */

import { IronbodySkillEffect, type IronbodyDeps, type IronbodyConfig } from './IronbodySkillEffect.js';

export class IronbodyMk2SkillEffect extends IronbodySkillEffect {
  override readonly skillId = 'ironbody_evolved';

  constructor(deps: IronbodyDeps, config: Partial<IronbodyConfig> = {}) {
    super(deps, {
      baseDamageReduction: 0.35,             // 35% incoming DR (was 25%)
      movementSpeedMultiplier: 0.8,          // 20% penalty (was 30%)
      staggerDurationMs: 350,               // 0.35s stagger (was 0.2s)
      ...config,
    });
  }
}
